<template>
  <div class="columns is-multiline">
    <div class="column is-half is-full-touch">
      <window title="Anchor links, form buttons, submit inputs, reset inputs" height="100%">
        <div class="buttons">
          <a class="button">Anchor</a>
          <button class="button">Button</button>
          <input class="button" type="submit" value="Submit input">
          <input class="button" type="reset" value="Reset input">
        </div>
      </window>
    </div>
    <div class="column is-half is-full-touch">
      <window title="Colors">
        <div class="buttons">
          <a class="button is-white">White</a>
          <a class="button is-light">Light</a>
          <a class="button is-dark">Dark</a>
          <a class="button is-black">Black</a>
          <a class="button is-text">Text</a>
          <a class="button is-primary">Primary</a>
          <a class="button is-link">Link</a>
          <a class="button is-info">Info</a>
          <a class="button is-success">Success</a>
          <a class="button is-warning">Warning</a>
          <a class="button is-danger">Danger</a>
        </div>
      </window>
    </div>
    <div class="column is-half is-full-touch">
      <window title="Styles - Outlined" height="100%">
        <div class="buttons">
          <a class="button is-outlined">Outlined</a>
          <a class="button is-primary is-outlined">Outlined</a>
          <a class="button is-link is-outlined">Outlined</a>
          <a class="button is-info is-outlined">Outlined</a>
          <a class="button is-success is-outlined">Outlined</a>
          <a class="button is-danger is-outlined">Outlined</a>
        </div>
      </window>
    </div>
    <div class="column is-half is-full-touch">
      <window title="Styles - Inverted
      (the text color becomes the background color, and vice-versa)">
        <div class="callout is-primary">
          <div class="buttons">
            <a class="button is-primary is-inverted">Inverted</a>
            <a class="button is-link is-inverted">Inverted</a>
            <a class="button is-info is-inverted">Inverted</a>
            <a class="button is-success is-inverted">Inverted</a>
            <a class="button is-danger is-inverted">Inverted</a>
          </div>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Styles - Invert Outlined
      (the invert color becomes the text and border colors)">
        <div class="callout is-primary">
          <div class="buttons">
            <a class="button is-primary is-inverted is-outlined">Invert Outlined</a>
            <a class="button is-link is-inverted is-outlined">Invert Outlined</a>
            <a class="button is-info is-inverted is-outlined">Invert Outlined</a>
            <a class="button is-success is-inverted is-outlined">Invert Outlined</a>
            <a class="button is-danger is-inverted is-outlined">Invert Outlined</a>
          </div>
        </div>
      </window>
    </div>
    <div class="column is-half is-full-touch">
      <window title="Sizes">
        <div class="buttons">
          <a class="button is-small">Small</a>
          <a class="button">Normal</a>
          <a class="button is-medium">Medium</a>
          <a class="button is-large">Large</a>
        </div>
      </window>
    </div>
    <div class="column is-half is-full-touch">
      <window title="Rounded" height="100%">
        <div class="buttons">
          <a class="button is-rounded">Rounded</a>
          <a class="button is-primary is-rounded">Rounded</a>
          <a class="button is-link is-rounded">Rounded</a>
          <a class="button is-info is-rounded">Rounded</a>
          <a class="button is-success is-rounded">Rounded</a>
          <a class="button is-danger is-rounded">Rounded</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Normal">
        <div class="buttons">
          <a class="button">Normal</a>
          <a class="button is-primary">Normal</a>
          <a class="button is-link">Normal</a>
          <a class="button is-info">Normal</a>
          <a class="button is-success">Normal</a>
          <a class="button is-warning">Normal</a>
          <a class="button is-danger">Normal</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Hover">
        <div class="buttons">
          <a class="button is-hovered">Hover</a>
          <a class="button is-primary is-hovered">Hover</a>
          <a class="button is-link is-hovered">Hover</a>
          <a class="button is-info is-hovered">Hover</a>
          <a class="button is-success is-hovered">Hover</a>
          <a class="button is-warning is-hovered">Hover</a>
          <a class="button is-danger is-hovered">Hover</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Focus">
        <div class="buttons">
          <a class="button is-focused">Focus</a>
          <a class="button is-primary is-focused">Focus</a>
          <a class="button is-link is-focused">Focus</a>
          <a class="button is-info is-focused">Focus</a>
          <a class="button is-success is-focused">Focus</a>
          <a class="button is-warning is-focused">Focus</a>
          <a class="button is-danger is-focused">Focus</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Active">
        <div class="buttons">
          <a class="button is-active">Active</a>
          <a class="button is-primary is-active">Active</a>
          <a class="button is-link is-active">Active</a>
          <a class="button is-info is-active">Active</a>
          <a class="button is-success is-active">Active</a>
          <a class="button is-warning is-active">Active</a>
          <a class="button is-danger is-active">Active</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Loading">
        <div class="buttons">
          <a class="button is-loading">Loading</a>
          <a class="button is-primary is-loading">Loading</a>
          <a class="button is-link is-loading">Loading</a>
          <a class="button is-info is-loading">Loading</a>
          <a class="button is-success is-loading">Loading</a>
          <a class="button is-warning is-loading">Loading</a>
          <a class="button is-danger is-loading">Loading</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Disable">
        <div class="buttons">
          <a class="button" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-primary" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-link" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-info" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-success" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-warning" title="Disabled button" disabled="">Disabled</a>
          <a class="button is-danger" title="Disabled button" disabled="">Disabled</a>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="With Font Awesome icons">
        <p class="buttons">
          <a class="button">
            <span class="icon is-small">
              <i class="fas fa-bold"></i>
            </span>
          </a>
          <a class="button">
            <span class="icon is-small">
              <i class="fas fa-italic"></i>
            </span>
          </a>
          <a class="button">
            <span class="icon is-small">
              <i class="fas fa-underline"></i>
            </span>
          </a>
        </p>
        <p class="buttons">
          <a class="button">
            <span class="icon">
              <i class="fab fa-github"></i>
            </span>
            <span>GitHub</span>
          </a>
          <a class="button is-primary">
            <span class="icon">
              <i class="fab fa-twitter"></i>
            </span>
            <span>Twitter</span>
          </a>
          <a class="button is-success">
            <span class="icon is-small">
              <i class="fas fa-check"></i>
            </span>
            <span>Save</span>
          </a>
          <a class="button is-danger is-outlined">
            <span>Delete</span>
            <span class="icon is-small">
              <i class="fas fa-times"></i>
            </span>
          </a>
        </p>
        <p class="buttons">
          <a class="button is-small">
            <span class="icon is-small">
              <i class="fab fa-github"></i>
            </span>
            <span>GitHub</span>
          </a>
          <a class="button">
            <span class="icon">
              <i class="fab fa-github"></i>
            </span>
            <span>GitHub</span>
          </a>
          <a class="button is-medium">
            <span class="icon">
              <i class="fab fa-github"></i>
            </span>
            <span>GitHub</span>
          </a>
          <a class="button is-large">
            <span class="icon is-medium">
              <i class="fab fa-github"></i>
            </span>
            <span>GitHub</span>
          </a>
        </p>
      </window>
    </div>
    <div class="column is-half">
      <window title="Button group" height="100%">
        <div class="field is-grouped">
          <p class="control">
            <a class="button is-link">
              Save
            </a>
          </p>
          <p class="control">
            <a class="button">
              Cancel
            </a>
          </p>
          <p class="control">
            <a class="button is-danger">
              Delete
            </a>
          </p>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Button addons" height="100%">
        <div class="field has-addons">
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-left"></i>
              </span>
              <span>Left</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-center"></i>
              </span>
              <span>Center</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-right"></i>
              </span>
              <span>Right</span>
            </a>
          </p>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="Button group with addons" height="100%">
        <div class="field has-addons">
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-bold"></i>
              </span>
              <span>Bold</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-italic"></i>
              </span>
              <span>Italic</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-underline"></i>
              </span>
              <span>Underline</span>
            </a>
          </p>
        </div>

        <div class="field has-addons">
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-left"></i>
              </span>
              <span>Left</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-center"></i>
              </span>
              <span>Center</span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="fas fa-align-right"></i>
              </span>
              <span>Right</span>
            </a>
          </p>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="List of buttons" height="100%">
        <div class="buttons">
          <span class="button is-success">Save changes</span>
          <span class="button is-info">Save and continue</span>
          <span class="button is-danger">Cancel</span>
        </div>
      </window>
    </div>
    <div class="column is-half">
      <window title="List of buttons">
        <div class="buttons">
          <span class="button">One</span>
          <span class="button">Two</span>
          <span class="button">Three</span>
          <span class="button">Four</span>
          <span class="button">Five</span>
          <span class="button">Six</span>
          <span class="button">Seven</span>
          <span class="button">Eight</span>
          <span class="button">Nine</span>
          <span class="button">Ten</span>
          <span class="button">Eleven</span>
          <span class="button">Twelve</span>
          <span class="button">Thirteen</span>
          <span class="button">Fourteen</span>
          <span class="button">Fifteen</span>
          <span class="button">Sixteen</span>
          <span class="button">Seventeen</span>
          <span class="button">Eighteen</span>
          <span class="button">Nineteen</span>
          <span class="button">Twenty</span>
        </div>
      </window>
    </div>
    <div class="column is-one-third">
      <window title="List of buttons" height="100%">
        <div class="buttons has-addons">
          <span class="button">Yes</span>
          <span class="button">Maybe</span>
          <span class="button">No</span>
        </div>
      </window>
    </div>
    <div class="column is-one-third">
      <window title="List of buttons" height="100%">
        <div class="buttons has-addons is-centered">
          <span class="button">Yes</span>
          <span class="button">Maybe</span>
          <span class="button">No</span>
        </div>

        <div class="buttons has-addons is-right">
          <span class="button">Yes</span>
          <span class="button">Maybe</span>
          <span class="button">No</span>
        </div>
      </window>
    </div>
    <div class="column is-one-third">
      <window title="List of buttons" height="100%">
        <div class="buttons has-addons">
          <span class="button is-success is-selected">Yes</span>
          <span class="button">Maybe</span>
          <span class="button">No</span>
        </div>

        <div class="buttons has-addons">
          <span class="button">Yes</span>
          <span class="button is-info is-selected">Maybe</span>
          <span class="button">No</span>
        </div>

        <div class="buttons has-addons">
          <span class="button">Yes</span>
          <span class="button">Maybe</span>
          <span class="button is-danger is-selected">No</span>
        </div>
      </window>
    </div>
  </div>
</template>


<script>
export default {};
</script>

<style scoped>
.columns is-multiline is-mobile {
  align-items: stretch;
}
.callout {
  background-color: #f5f5f5;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
  position: relative;
}
.callout.is-primary {
  background-color: #2297cd;
  color: #fff;
}
</style>
